import type { DefaultTheme } from 'styled-components';

export const myTheme: DefaultTheme = {
  palette: {
    primary: {
      orange: '#FF8D4E',
    },
    error: {
      main: '#FF334B',
    },
    success: {
      main: '#58B99D',
    },
    grey: {
      50: '#F3F3F3',
      100: '#EFF0F5',
      200: '#D8D9E1',
      300: '#A9ABB6',
      400: '#727582',
      500: '#505462',
    },
    black: {
      main: '#1A1C2D',
    },
    white: {
      main: '#FFF',
    },
  },
};
